import React from 'react';

const PaymentCardSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {[...Array(4)].map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow-lg overflow-hidden card-hover animate-pulse"
        >
          <div className="flex justify-between items-center p-6 hover:bg-gray-50">
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-2 justify-between">
                    <div className="flex items-center gap-4">
                      <div className="h-5 w-32 bg-gray-200 rounded-sm"></div>
                      <div className="h-6 w-20 bg-gray-200 rounded-sm"></div>
                    </div>
                    <div className="ml-4 flex items-center">
                      <div className="h-10 w-24 bg-gray-200 rounded-lg"></div>
                      <div className="ml-2 w-5 h-5 bg-gray-200 rounded-full"></div>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div className="h-4 w-28 bg-gray-200 rounded-sm"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentCardSkeleton;
